import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Generic optimistic update hook.
 * Uses setQueriesData for pattern matching - updates all queries
 * that START with the provided queryKey prefix.
 */
export function useOptimisticUpdate<T>(
  queryKey: unknown[],
  updateFn: (oldData: T | undefined, ...args: any[]) => T | undefined
) {
  const queryClient = useQueryClient();
  return useCallback(
    (...args: any[]) => {
      queryClient.setQueriesData<T>({ queryKey }, (oldData) =>
        updateFn(oldData, ...args)
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(queryKey), queryClient, updateFn]
  );
}
